<template>
  <div class="priceScreening">
    <Form @submitSuccess="getList" ref="form"/>
    <div class="groupButton">
      <AppButton customType="default" @click="addMenu">添加分类</AppButton>
    </div>
    <BasicTable
      hiddenFooter
      :tableData="tableData"
      :columns="columns" 
      :node="node"
      >
      <template v-slot:add_time="{ item }">
        {{item.add_time*1000 | dateFormat('YYYY-MM-DD') }}
      </template>
      <template v-slot:operate="{ item }">
        <AppButton type="primary" plain size="small" @click="editMenu(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton type="primary" plain size="small" @click="deleteMenu(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { ArticleService } from '../../service/article.service'
import Form from './formArticleClassification';
const columns = [
  { name: '价格', key: 'name' },
  { name: '创建时间',key: 'add_time', type: 'custom'},
  { name: '操作', key: 'operate', type: 'custom'}

];
  export default {
    name: 'articleClassification',
    components: { Form },
    data() {
      return {
        fields: [],
        tableData: [],
        columns,
        node: []
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await ArticleService.getClassficationList();
        this.tableData = data;
      },
      addMenu() {
        this.$refs.form.open('add',{});
      },
      editMenu(data) {
        this.$refs.form.open('edit', data);
      },
      deleteMenu(data) {
        MessageBox.confirm('确定要删除这条分类吗？', '删除分类').then(async () => {
          await ArticleService.delArticleClassification(data.id)
          this.getList();
        })
      },
      filter() {
        this.getList();
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1vw;
}
</style>